import { render, staticRenderFns } from "./VersionSave.vue?vue&type=template&id=4cbc18ca&"
import script from "./VersionSave.vue?vue&type=script&lang=js&"
export * from "./VersionSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports